import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminAIDailyAudit = lazy(() => import("@/pages/admin/AdminAIDailyAudit"));

export const Route = createFileRoute("/admin/ai-daily-audit")({
  component: AdminAIDailyAudit,
});
